module.exports = __webpack_public_path__ + "static/img/08.4b3f29d3.gif";